<template>
  <div>
    <div class="title">
      <el-button
        type="primary"
        :class="tableType == 3 ? 'ac' : ''"
        @click="changeTable(3);">活动数据</el-button>
      <el-button 
        type="primary"
        :class="tableType == 2 ? 'ac' : ''"
        @click="changeTable(2);">客服数据</el-button>
      <el-button
        type="primary"
        :class="tableType == 1 ? 'ac' : ''"
        @click="changeTable(1);"
       >资料数据</el-button>
    </div>
    <div class="block">
      <el-date-picker
        v-model="value"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="getlist();"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </div>
    <select
      v-model="build_type"
      name="选择楼盘类型"
      @change="filterHandler2();"
    >
      <option value="住宅"> 住宅</option>
      <option value="公寓"> 公寓</option>
    </select>
    <SjAndYuny
      v-show="tableType == 1"
      :person="person"
      :finishCount="finishCount"
      :build_type="build_type"
      :tableType="tableType"
      :districts="districts"
      :userAll="userAll"
    >
    </SjAndYuny>
    <div v-show="tableType == 2">
      <div v-if="!value2">未选定时间，默认展示最近一天</div>
      <div v-if="value2">
        已选时间:开始时间:{{ value2[0] }}结束时间:{{ value2[1] }}
      </div>
      <el-table :data="kefu">
        <el-table-column
          :filters="filterList11"
          :filter-method="filterHandler1"
          label="日期"
          prop="date"
        >
        </el-table-column>
        <el-table-column label="人员" prop="name"> </el-table-column>
        <el-table-column
          label="群聊活跃个数"
          prop="chat_num"
        >
        </el-table-column>
        <el-table-column
          label="群聊活跃比例"
          prop="chat_rate"
        >
        </el-table-column>
        <el-table-column label="主动">
          <el-table-column label="主动联系">
            <el-table-column label="私聊人数" prop="active_user" sortable>
            </el-table-column>
            <el-table-column label="私聊条数" prop="active_talk" sortable>
            </el-table-column>
            <el-table-column label="群聊条数" prop="group_talk" sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column label="客户回复">
            <el-table-column label="回复人数" prop="active_reply_user" sortable>
            </el-table-column>
            <el-table-column label="回复条数" prop="active_reply_talk" sortable>
            </el-table-column>
            <el-table-column label="回复率" prop="active_reply_rate" sortable>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="被动">
          <el-table-column label="咨询">
            <el-table-column label="总人数" prop="passive_user" sortable>
            </el-table-column>
            <el-table-column
              label="回复人数"
              prop="passive_reply_user"
              sortable
            >
            </el-table-column>
            <el-table-column label="完成率" prop="passive_reply_rate" sortable>
            </el-table-column>
            <el-table-column label="速度" prop="passive_reply_speed" sortable>
              <template slot-scope="{ row }">
                <div>{{ row["passive_reply_speed"] + "s" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="深度" prop="passive_reply_depth" sortable>
            </el-table-column>
          </el-table-column>
          <el-table-column label="问答">
            <el-table-column label="总人数" prop="ask_user" sortable>
            </el-table-column>
            <el-table-column label="回复人数" prop="ask_reply_user" sortable>
            </el-table-column>
            <el-table-column label="完成率" prop="ask_reply_rate" sortable>
            </el-table-column>
            <el-table-column label="速度" prop="ask_reply_speed" sortable>
              <template slot-scope="{ row }">
                <div>{{ row["ask_reply_speed"] + "s" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="深度" prop="ask_reply_depth" sortable>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="顾问联系">
          <el-table-column label="私聊人数" prop="guwen_user"></el-table-column>
          <el-table-column label="私聊条数" prop="guwen_talk"></el-table-column>
        </el-table-column>
        <el-table-column label="积分"> </el-table-column>
      </el-table>
    </div>
    <div v-show="tableType == 3">
      <div v-if="!value3">未选定时间，默认展示最近一天</div>
      <div v-if="value3">
        已选时间:开始时间:{{ value3[0] }}结束时间:{{ value3[1] }}
      </div>
      <el-table :data="activity">
        <el-table-column
          :filters="filterList11"
          :filter-method="filterHandler1"
          label="日期"
          prop="date"
        >
        </el-table-column>
        <el-table-column
          label="人员"
          :filters="filterList12"
          :filter-method="filterHandler1"
          prop="userName"
        >
        </el-table-column>
        <el-table-column label="销售">
          <el-table-column label="活动">
            <el-table-column label="分享人数" prop="activityShareNum" sortable> </el-table-column>
            <el-table-column label="参与人数" prop="joinActivityNum" sortable> </el-table-column>
            <el-table-column label="参与比例" prop="activityRate" sortable> </el-table-column>
            <el-table-column label="活动个数" prop="activityNum" sortable> </el-table-column>
          </el-table-column>
          <el-table-column label="爆点">
            <el-table-column label="分享人数" prop="saleShareNum" sortable>
            </el-table-column>
            <el-table-column label="参与人数" prop="joinNum" sortable>
            </el-table-column>
            <el-table-column label="参与比例" prop="rate" sortable>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="客户">
          <!-- <el-table-column label="活动">
            <el-table-column label="分享人数" sortable> </el-table-column>
            <el-table-column label="参与人数" sortable> </el-table-column>
            <el-table-column label="参与比例" sortable> </el-table-column>
            <el-table-column label="活动个数" sortable> </el-table-column>
          </el-table-column> -->
          <el-table-column label="爆点">
            <el-table-column label="分享人数" prop="customerShareNum" sortable>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <!-- <el-table-column label="积分" sortable> </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      user: {
        杭州: [
          {
            mainUser: "宋建平",
            secoendUser: "郭慧敏",
            area: ["临安区", "拱墅区", "钱塘区"]
          },
          {
            mainUser: "徐嘉琳",
            secoendUser: "敖鸿波",
            area: ["富阳区", "西湖区", "上城区", "临平区"]
          },
          {
            mainUser: "刘梦恬",
            secoendUser: "曲文龙",
            area: ["萧山区", "滨江区", "余杭区"]
          }
        ],
        苏州: [
          {
            mainUser: "宋建平",
            secoendUser: "暂无",
            area: ["昆山市", "吴江区"]
          },
          {
            mainUser: "徐嘉琳",
            secoendUser: "暂无",
            area: ["高新区", "相城区"]
          },
          {
            mainUser: "刘梦恬",
            secoendUser: "暂无",
            area: ["工业园区", "姑苏区", "吴中区"]
          }
        ]
      },
      finishCount: 85,
      personLength: [],
      build_type: "住宅",
      filterList11: [],
      filterList12: [],
      value: "",
      value2: "",
      value3: "",
      tableType: 3,
      person: [],
      activity: [],
      kefu: [],
      districts: [],
      userAll: []
    };
  },
  mounted() {
    this.getlist3();
  },
  methods: {
    getlist() {
      // if (this.tableType == 1) {
      //   this.getlist1();
      // }
      if (this.tableType == 2) {
        this.getlist2();
        this.value2 = this.value;
      }
      if (this.tableType == 3) {
        this.getlist3();
        this.value3 = this.value;
      }
    },
    getlist2() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getstatus", {
          params: {
            time: this.value
          }
        })
        .then(res => {
          this.$close();
          this.kefu = res.data.data;
          console.log('数据',res);
        })
        .catch(err => {
          this.$close();
          console.log("err", err);
        });
    },
    getfilterValue(list) {
      let timeList = new Set();
      let nameList = new Set();
      list.forEach(item => {
        timeList.add(item["date"]);
        nameList.add(item["userName"]);
      });
      timeList = Array.from(timeList).sort((a, b) => a - b);
      nameList = Array.from(nameList);
      console.log(timeList,nameList)
      timeList = timeList.map(item => {
        return {
          text: item,
          value: item
        };
      });
      nameList = nameList.map(item => {
        return {
          text: item,
          value: item
        };
      });
      return [timeList, nameList];
    },
    getlist1() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "getziliao", {
          params: {
            build_type: this.build_type
          }
        })
        .then(res => {
          this.$close();
          this.shaixuan(res.data.data);
        })
        .catch(() => {
          this.$close();
        });
    },
    shaixuan(person) {
      let aaa = person;
      console.log(aaa);
      let map = {};
      let city = this.$store.state.Counter.city;
      let linan = [];
      let districts = [];
      let user = new Set();
      let userAll = [];
      for (var item of aaa) {
        if (this.user[city][0].area.includes(item.district)) {
          item.fuUser = this.user[city][0].secoendUser;
          user.add(this.user[city][0].secoendUser);
          item.user = this.user[city][0].mainUser;
          if (!map[item.district]) {
            map[item.district] = [item];
          } else {
            map[item.district].push(item);
          }
        } else if (this.user[city][1].area.includes(item.district)) {
          item.fuUser = this.user[city][1].secoendUser;
          user.add(this.user[city][1].secoendUser);
          item.user = this.user[city][1].mainUser;
          if (!map[item.district]) {
            map[item.district] = [item];
          } else {
            map[item.district].push(item);
          }
        } else if (this.user[city][2].area.includes(item.district)) {
          item.fuUser = this.user[city][2].secoendUser;
          user.add(this.user[city][2].secoendUser);
          item.user = this.user[city][2].mainUser;
          if (!map[item.district]) {
            map[item.district] = [item];
          } else {
            map[item.district].push(item);
          }
        }
      }
      let all = Object.values(map);
      let districtsAll = Object.keys(map);
      for (let item of all) {
        linan = linan.concat(item);
      }
      for (let item of districtsAll) {
        districts = districts.concat({
          text: item,
          value: item
        });
      }
      user = Array.from(user);
      for (let item of user) {
        userAll = userAll.concat({
          text: item,
          value: item
        });
      }
      console.log(linan, all, map);
      this.person = linan;
      this.districts = districts;
      this.userAll = userAll;
    },
    getlist3() {
      this.$open();
      this.$axios
        .get(this.$url_prefix + "activity", {
          params: {
            time: this.value
          }
        })
        .then(res => {
          this.$close();
          let list = this.getfilterValue(res.data.data);
          this.filterList11 = list[0];
          this.filterList12 = list[1];
          this.activity = res.data.data;
          console.log(res);
          console.log("activity", this.activity,list);
        })
        .catch(err => {
          this.$close();
          console.log("err", err);
        });
    },
    changeTable(count) {
      this.tableType = count;
      if (count == 2 && this.kefu.length == 0) {
        this.getlist2();
      }
      if (count == 1 && this.person.length == 0) {
        this.getlist1();
      }
      if (count == 3 && this.activity.length == 0) {
        this.getlist3();
      }
      this.value = "";
    },
    //68 27 21 41 18 24 38 70 8 58
    merge({ row, column, rowIndex, columnIndex }) {
      let length1 =
        this.personLength[0] + this.personLength[1] + this.personLength[2];
      let length2 =
        this.personLength[3] +
        this.personLength[4] +
        this.personLength[5] +
        this.personLength[6];
      let length3 =
        this.personLength[7] + this.personLength[8] + this.personLength[9];
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: length1,
            colspan: 1
          };
        } else if (rowIndex === length1) {
          return {
            rowspan: length2,
            colspan: 1
          };
        } else if (rowIndex === length1 + length2) {
          return {
            rowspan: length3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: this.personLength[0],
            colspan: 1
          };
        } else if (rowIndex === this.personLength[0]) {
          return {
            rowspan: this.personLength[1],
            colspan: 1
          };
        } else if (rowIndex === this.personLength[0] + this.personLength[1]) {
          return {
            rowspan: this.personLength[2],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] + this.personLength[1] + this.personLength[2]
        ) {
          return {
            rowspan: this.personLength[3],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] +
            this.personLength[1] +
            this.personLength[2] +
            this.personLength[3]
        ) {
          return {
            rowspan: this.personLength[4],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] +
            this.personLength[1] +
            this.personLength[2] +
            this.personLength[3] +
            this.personLength[4]
        ) {
          return {
            rowspan: this.personLength[5],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] +
            this.personLength[1] +
            this.personLength[2] +
            this.personLength[3] +
            this.personLength[4] +
            this.personLength[5]
        ) {
          return {
            rowspan: this.personLength[6],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] +
            this.personLength[1] +
            this.personLength[2] +
            this.personLength[3] +
            this.personLength[4] +
            this.personLength[5] +
            this.personLength[6]
        ) {
          return {
            rowspan: this.personLength[7],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] +
            this.personLength[1] +
            this.personLength[2] +
            this.personLength[3] +
            this.personLength[4] +
            this.personLength[5] +
            this.personLength[6] +
            this.personLength[7]
        ) {
          return {
            rowspan: this.personLength[8],
            colspan: 1
          };
        } else if (
          rowIndex ===
          this.personLength[0] +
            this.personLength[1] +
            this.personLength[2] +
            this.personLength[3] +
            this.personLength[4] +
            this.personLength[5] +
            this.personLength[6] +
            this.personLength[7] +
            this.personLength[8]
        ) {
          return {
            rowspan: this.personLength[9],
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    filterHandler1(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterHandler2() {
      this.getlist1();
    },
    filterHandler11(value, row, column) {
      const property = column["property"];
      if (value == "无") {
        return row[property] === value;
      } else {
        return row[property] !== "无";
      }
    }
  }
};
</script>

<style>
/* 对于样式的切换的话，我们可以动态绑定一个class或者动态绑定样式，用三元判别来进行判断 */
.title {
  /* font-size:0;如果多个buton组件建有间距，可以设置布局或者使用sont-size为0来取消间距 */
  display: flex;
  justify-content: center;
}
.title .qiehuan {
  border: 1px solid;
}
.ac {
  background-color: rgb(127, 127, 192);
}
</style>



// WEBPACK FOOTER //
// src/page/yunYincount.vue